import {useQuery} from 'react-query'
import {InvoiceEditModalForm} from './InvoiceEditModalForm'
import {ID, isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {getInvoiceById} from '../core/_requests'
import {Dispatch, FC, SetStateAction} from 'react'
import {useListView} from '../core/ListViewProvider'
import {ListLoading} from '../../../../../../_metronic/helpers/components/ListLoading'

// The modal reads the same query to choose the form before the invoice is shown; react-query runs
// one request for both.
const useEditedInvoiceQuery = (itemIdForUpdate: ID, onError?: (error: unknown) => void) =>
  useQuery(
    `${QUERIES.INVOICES_LIST}-invoice-${itemIdForUpdate}`,
    () => {
      return getInvoiceById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: isNotEmpty(itemIdForUpdate),
      onError,
    }
  )

type props = {
  title: {
    title: string
    setTitle: Dispatch<SetStateAction<string>>
  }
  invoiceType: {
    invoiceType: number
    setInvoiceType: Dispatch<SetStateAction<number>>
  }
  invoiceTemplate: {
    invoiceTemplate: number
    setInvoiceTemplate: Dispatch<SetStateAction<number>>
  }
  closeFn?: () => void
  formType: {
    formType: number
    setFormType: Dispatch<SetStateAction<number>>
  }
}

const InvoiceEditModalFormWrapper: FC<props> = ({
  title,
  invoiceType,
  invoiceTemplate,
  closeFn,
  formType,
}) => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const {
    isLoading,
    data: invoice,
    error,
  } = useEditedInvoiceQuery(itemIdForUpdate, (err) => {
    setItemIdForUpdate(undefined)
    if (closeFn) closeFn()
    console.error(err)
  })

  if (!itemIdForUpdate) {
    return (
      <InvoiceEditModalForm
        invoice={null}
        title={title}
        invoiceType={invoiceType}
        invoiceTemplate={invoiceTemplate}
        closeFn={closeFn}
        formType={formType}
      />
    )
  }

  if (!isLoading && !error && invoice) {
    return (
      <InvoiceEditModalForm
        invoice={invoice}
        title={title}
        invoiceType={invoiceType}
        invoiceTemplate={invoiceTemplate}
        closeFn={closeFn}
        formType={formType}
      />
    )
  }

  if (isLoading) {
    return <ListLoading />
  }

  return null
}

export {InvoiceEditModalFormWrapper, useEditedInvoiceQuery}
